import { MessageCircle } from "lucide-react";

const WA_URL =
  "https://wa.me/4917641162064?text=" +
  encodeURIComponent("Hallo LLP Zaun&Garten, ich interessiere mich für eine Anfrage.");

export default function WhatsAppButton() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Per WhatsApp anfragen"
      data-testid="whatsapp-button"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1fb857] text-white font-semibold text-sm pl-4 pr-5 py-3.5 rounded-full shadow-xl shadow-[#25D366]/30 transition-all hover:-translate-y-0.5"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">Per WhatsApp anfragen</span>
    </a>
  );
}
